import { render, staticRenderFns } from "./SupportSettings.vue?vue&type=template&id=eec637c8&scoped=true&"
import script from "./SupportSettings.vue?vue&type=script&lang=js&"
export * from "./SupportSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eec637c8",
  null
  
)

export default component.exports